// Module
var code = `<section class="license-seats-discount-wrapper" role="status" aria-live><p>{{\$ctrl.data.message}}</p></section>`;
// Exports
export default code;